import Constant from '@/const';
import axios from 'axios';

const deleteBed = async id => {
  try {
    const response = await axios.delete(
      Constant.apiUrl.concat(`/master/bed/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default deleteBed;
